export enum LoginAction {
    Login = 1,
    RecuperarUsuario = 2,
    RecuperarContraseña = 3
}